<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapState, mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
// import axios from "axios";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Products",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Add Products",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Add Products",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      unitmodal_id: "",
      currentdate: moment(new Date()).format("YYYY-MM-DD"),

      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      is_uploading: false,
      existingProduct: [],
      nameError: "",
      unitError: "",
      categoryError: "",
      productError: "",
      sellingPriceError: "",
      branchError: "",
      UnitProductunitError: "",
      UnitqtyError: "",
      UnitsellingPriceError: "",

      // Value from user input for adding product
      data: {
        name: "",
        product: "",
        category: "",
        code: "",
        minimum: 10,
        selling_price: "",
        buying_price: "",
        quantity: 0,
        reserve_price: "",
        vat: 0,
        unit: "",
        otherunits: [],
        class: "",
        family: "",
        segment: "",
        cat: "",
        wholesale_reserveprice: "",
        wholesale_unitprice: "",
        item_type: "1"
      },

      // product units data
      units1: {
        unit: "",
        code: "",
        selling_price: "",
        base_quantity: 0,
        reserve_price: "",
        wholesale_reserveprice: "",
        wholesale_unitprice: "",
      },
      units2: {
        unit: "",
        code: "",
        selling_price: "",
        base_quantity: 0,
        reserve_price: "",
        wholesale_reserveprice: "",
        wholesale_unitprice: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("products", [
      "SaveStatus",
      "BProducts",
      "Units",
      "Categories",
      "Segments",
      "Families",
      "Classes",
      "EfrisCategories",
    ]),
    ...mapGetters("auth", ["MyUserPerm", "business", "branch"]),
    ...mapGetters("setting", ["GeneralSettings"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Products ? this.Products.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Products ? this.Products.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          this.closeModal(this.modal_id);
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchBProducts: "products/fetchBProducts",
      FetchUnits: "products/fetchUnits",
      AddProduct: "products/addProduct",
      FetchCategories: "products/fetchPCategories",
      SendProducts: "products/TransferProducts",
      FetchSegments: "products/fetchSegments",
      FetchFamilies: "products/fetchFamilies",
      FetchClasses: "products/fetchClasses",
      FetchEfrisCategories: "products/fetchCategories",
      AddProductUnit: "products/addProductUnit",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      EfrisPdtImport: "products/EfrisPdtImport",
      EfrisTaxImport: "products/updateTaxCategory",
      SyncProducts: "products/SyncProducts",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    assignName() {
      this.data.name = this.data.product;
    },
    addBuyCommas() {
      this.data.buying_price = this.thousandSeperator(this.data.buying_price);
    },
    addSellCommas() {
      this.data.selling_price = this.thousandSeperator(this.data.selling_price);
    },
    addReserveCommas() {
      this.data.reserve_price = this.thousandSeperator(this.data.reserve_price);
    },
    addUnitSellCommas1() {
      this.units1.selling_price = this.thousandSeperator(
        this.units1.selling_price,
      );
    },
    addUnitReserveCommas1() {
      this.units1.reserve_price = this.thousandSeperator(
        this.units1.reserve_price,
      );
    },
    addUnitSellCommas2() {
      this.units2.selling_price = this.thousandSeperator(
        this.units2.selling_price,
      );
    },
    addUnitReserveCommas2() {
      this.units2.reserve_price = this.thousandSeperator(
        this.units2.reserve_price,
      );
    },
    //add commas separators for wholesale price and wolesale reserve price
    addWholesaleSellCommas() {
      this.data.wholesale_unitprice = this.thousandSeperator(
        this.data.wholesale_unitprice,
      );
    },
    addWholesaleReserveCommas() {
      this.data.wholesale_reserveprice = this.thousandSeperator(
        this.data.wholesale_reserveprice,
      );
    },

    addProduct(modalId) {
      this.modal_id = modalId;
      if (this.data.category === "") {
        this.categoryError = "Category field is required";
        return;
      } else {
        this.categoryError = "";
      }
      if (this.data.name === "") {
        this.nameError = "Product name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.existingProduct.length) {
        this.nameError = this.data.name + " exists already please";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.unit === "") {
        this.unitError = "Product unit is required";
        return;
      } else {
        this.unitError = "";
      }

      // Wrap data in items array for backend validation
      this.AddProduct({ items: [this.data] });
    },

    resetAdd() {
      this.data.name = "";
      this.data.product = "";
      this.data.category = "";
      this.data.code = "";
      this.data.minimum = 10;
      this.data.selling_price = "";
      this.data.buying_price = "";
      this.data.quantity = 0;
      this.data.reserve_price = "";
      this.data.wholesale_reserveprice = "";
      this.data.wholesale_unitprice = "";
      this.data.vat = 0;
      this.data.unit = "";
      this.data.segment = "";
      this.data.class = "";
      this.data.family = "";
      this.data.cat = "";
      this.data.item_type = "1";
      this.units1.unit = "";
      this.units1.code = "";
      this.units1.selling_price = "";
      this.units1.base_quantity = "";
      this.units1.reserve_price = "";
      this.units1.wholesale_reserveprice = "";
      this.units1.wholesale_unitprice = "";
      this.units2.unit = "";
      this.units2.code = "";
      this.units2.selling_price = "";
      this.units2.base_quantity = "";
      this.units2.reserve_price = "";
      this.units2.wholesale_reserveprice = "";
      this.units2.wholesale_unitprice = "";
      this.data.otherunits = [];
      this.modal_id = "";
      this.unitmodal_id = "";
    },

    resetError() {
      this.nameError = "";
      this.categoryError = "";
      this.unitError = "";
      this.productError = "";
      this.sellingPriceError = "";
      this.UnitProductunitError = "";
      this.UnitqtyError = "";
      this.UnitsellingPriceError = "";
    },

    resetUnitError() {
      this.UnitProductunitError = "";
      this.UnitqtyError = "";
      this.UnitsellingPriceError = "";
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
      this.resetError();
      this.resetAdd();
    },
    //== close modal
    closeUnitModal(modalId) {
      this.resetUnitError();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    // import efris pdts
    ImportEfrisPdts(modalId) {
      this.EfrisPdtImport();
      this.closeModal(modalId);
    },

    // import efris pdts
    ImportEfrisTax(modalId) {
      this.EfrisTaxImport();
      this.closeModal(modalId);
    },

    // Fetch Segment
    FetchSeg() {
      if (this.Segments == "") {
        this.FetchSegments();
      }
    },

    // Fetch Families
    FetchFamily() {
      this.FetchFamilies(this.data.segment);
    },

    // Fetch Classes
    FetchClass() {
      this.FetchClasses(this.data.family);
    },

    // Synchronize pending products
    SyncPdts(modal) {
      this.SyncProducts();
      this.closeModal(modal);
    },

    // Fetch Categories
    FetchCat() {
      this.FetchEfrisCategories(this.data.class);
    },

    // Add product units
    addProductUnit(modalId) {
      if (this.units1.unit === "") {
        this.UnitProductunitError = "Unit Name is required";
        return;
      } else {
        this.UnitProductunitError = "";
      }
      if (this.units1.base_quantity === "") {
        this.UnitqtyError = "Unit Base Quantity is required";
        return;
      } else {
        this.UnitqtyError = "";
      }
      if (this.units1.selling_price == "") {
        this.UnitsellingPriceError = "Unit selling price is required";
        return;
      } else {
        this.UnitsellingPriceError = "";
      }
      this.data.otherunits.push(this.units1, this.units2);

      this.closeUnitModal(modalId);
    },
  },
  created() {
    this.FetchBProducts();
    this.FetchUnits();
    this.FetchCategories();
    this.FetchGeneralSettings();
    this.FetchSeg();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <b-btn-group>
                  <b-button v-b-modal.efris-products-modal variant="warning"
                    ><i class="fa fa-plus"></i> Efris Import
                    <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Spinning"
                    ></b-spinner>
                  </b-button>
                  <b-button v-b-modal.efris-tax-modal variant="success"
                    ><i class="fa fa-plus"></i> Tax Category
                    <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Spinning"
                    ></b-spinner>
                  </b-button>
                </b-btn-group>
              </div>

              <div class="col-md-3" align="right">
                <b-button v-b-modal.synch-products-modal variant="info"
                  ><i class="fa fa-check"></i> Synchronize Products</b-button
                >
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <!-- form for adding products -->
              <div class="row">
                <div class="col-md-6 form-group mb-3">
                  <label
                    >Select Segment <span class="text-danger">*</span></label
                  >
                  <model-list-select
                    :list="Segments ? Segments : []"
                    v-model="data.segment"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Segment"
                    @input="FetchFamily()"
                  >
                  </model-list-select>
                </div>
                <div class="col-md-6 form-group mb-3">
                  <label>Select Family<span class="text-danger">*</span></label>
                  <model-list-select
                    :list="Families ? Families : []"
                    v-model="data.family"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Family"
                    @input="FetchClass()"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 form-group mb-3">
                  <label>Select Class <span class="text-danger">*</span></label>
                  <model-list-select
                    :list="Classes ? Classes : []"
                    v-model="data.class"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Class"
                    @input="FetchCat()"
                  >
                  </model-list-select>
                </div>
                <div class="col-md-6 form-group mb-3">
                  <label
                    >Select Category <span class="text-danger">*</span></label
                  >
                  <model-list-select
                    :list="EfrisCategories ? EfrisCategories : []"
                    v-model="data.cat"
                    option-value="code"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Category"
                  >
                  </model-list-select>
                  <div class="text-danger" v-if="categoryError">
                    <em>{{ categoryError }}</em>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label
                      >Select Business Category
                      <span class="text-danger">*</span></label
                    >
                    <model-list-select
                      :list="Categories ? Categories : []"
                      v-model="data.category"
                      option-value="id"
                      option-text="catName"
                      class="mb-3"
                      placeholder="Select Business Category"
                      @input="resetError()"
                    >
                    </model-list-select>
                    <div class="text-danger" v-if="categoryError">
                      <em>{{ categoryError }}</em>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label>Select Product type</label>
                    <select v-model="data.item_type" class="form-control">
                      <option value="1">Product</option>
                      <option value="0">Service</option>
                      <option value="2">Consumable</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label
                      >Select Global Product
                      <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      v-model="data.product"
                      list="products"
                      placeholder="Choose Product"
                      @input="resetError(), assignName()"
                      autocomplete="off"
                    />
                    <datalist id="products">
                      <option
                        v-for="(pdt, p) in BProducts"
                        :data-value="pdt.name"
                        :key="p"
                      >
                        {{ pdt.name }}
                      </option>
                    </datalist>
                    <div class="text-danger" v-if="productError">
                      <em>{{ productError }}</em>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label
                      >Product Name (<small>The Name you want to use</small
                      >)<span class="text-danger">*</span></label
                    >
                    <div class="input-group">
                      <input
                        type="text"
                        placeholder="Enter Product Name"
                        class="form-control"
                        @input="resetError()"
                        v-model="data.name"
                      />
                    </div>
                    <div class="text-danger" v-if="nameError">
                      <em>{{ nameError }}</em>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label
                      >Minimum Quantity (<small>Warn Quantity</small>)</label
                    >
                    <div class="input-group">
                      <input
                        type="number"
                        placeholder="Warn Quantity"
                        class="form-control"
                        v-model="data.minimum"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label>Product Code</label>
                    <div class="input-group">
                      <input
                        type="text"
                        placeholder="Enter Product Code"
                        class="form-control"
                        v-model="data.code"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label>Quantity In Stock</label>
                    <div class="input-group">
                      <input
                        type="number"
                        placeholder="InStock"
                        class="form-control"
                        v-model="data.quantity"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-md-6 form-group mb-3">
                  <label>Select Unit <span class="text-danger">*</span></label>                  
                  <model-list-select
                    :list="Units ? Units : []"
                    v-model="data.unit"
                    option-value="code"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Units"
                  >
                  </model-list-select>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label>Buying Price</label>
                    <div class="input-group">
                      <input
                        type="text"
                        placeholder="Enter Product Unit Buying Price"
                        class="form-control"
                        v-model="data.buying_price"
                        @input="addBuyCommas()"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label
                      >Selling Price <span class="text-danger">*</span></label
                    >
                    <div class="input-group">
                      <input
                        type="text"
                        placeholder="Enter Product Unit Selling Price"
                        class="form-control"
                        v-model="data.selling_price"
                        @input="addSellCommas()"
                      />
                    </div>
                    <div class="text-danger" v-if="sellingPriceError">
                      <em>{{ sellingPriceError }}</em>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label>Reserve Price</label>
                    <div class="input-group">
                      <input
                        type="text"
                        placeholder="Enter Reserve Price"
                        class="form-control"
                        v-model="data.reserve_price"
                        @input="addReserveCommas()"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-md-6"
                    v-if="GeneralSettings.enable_wholeselling == 1"
                  >
                    <div class="form-group mb-3">
                      <label>Wholesale Price</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter Product Unit Selling Price"
                          class="form-control"
                          v-model="data.wholesale_unitprice"
                          @input="addWholesaleSellCommas()"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-6"
                    v-if="GeneralSettings.enable_wholeselling == 1"
                  >
                    <div class="form-group mb-3">
                      <label>Wholesale reserve Price</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter Reserve Price"
                          class="form-control"
                          v-model="data.wholesale_reserveprice"
                          @input="addWholesaleReserveCommas()"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="addProduct('add-product-modal')"
                  >
                    <i class="fa fa-check"></i>
                    Submit
                    <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Spinning"
                    ></b-spinner>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Product units modal starts -->
    <b-modal id="add-productunit-modal" size="lg" hide-footer>
      <template #modal-title> Add New Product Unit </template>
      <div class="row">
        <div class="col-md-6">
          <label><h5>Unit 1</h5></label>
          <div class="col-md-12">
            <div class="form-group mb-3">
              <label>Unit Name<span class="text-danger">*</span></label>
              <model-list-select
                :list="Units ? Units : []"
                v-model="units1.unit"
                option-value="id"
                option-text="name"
                class="mb-3"
                placeholder="Select Other Units"
              >
              </model-list-select>
              <div class="text-danger" v-if="UnitProductunitError">
                <em>{{ UnitProductunitError }}</em>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-3">
              <label>Product Code</label>
              <div class="input-group">
                <input
                  type="text"
                  placeholder="Product Unit Code"
                  class="form-control"
                  v-model="units1.code"
                />
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-3">
              <label>Base Quantity</label>
              <div class="input-group">
                <input
                  type="number"
                  placeholder="Base Quantity"
                  class="form-control"
                  v-model="units1.base_quantity"
                />
              </div>
              <div class="text-danger" v-if="UnitqtyError">
                <em>{{ UnitqtyError }}</em>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-3">
              <label>Selling Price <span class="text-danger">*</span></label>
              <div class="input-group">
                <input
                  type="text"
                  placeholder="Enter Product Unit Selling Price"
                  class="form-control"
                  v-model="units1.selling_price"
                  @input="addUnitSellCommas1()"
                />
              </div>
              <div class="text-danger" v-if="sellingPriceError">
                <em>{{ UnitsellingPriceError }}</em>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-3">
              <label>Reserve Price</label>
              <div class="input-group">
                <input
                  type="text"
                  placeholder="Enter Reserve Price"
                  class="form-control"
                  v-model="units1.reserve_price"
                  @input="addUnitReserveCommas1()"
                />
              </div>
            </div>
          </div>
          <div
            class="col-md-12"
            v-if="GeneralSettings.enable_wholeselling == 1"
          >
            <div class="form-group mb-3">
              <label>Wholesale Price</label>
              <div class="input-group">
                <input
                  type="text"
                  placeholder="Enter Wholesale Unit Selling Price"
                  class="form-control"
                  v-model="units1.wholesale_unitprice"
                />
              </div>
            </div>
          </div>
          <div
            class="col-md-12"
            v-if="GeneralSettings.enable_wholeselling == 1"
          >
            <div class="form-group mb-3">
              <label>Wholesale reserve Price</label>
              <div class="input-group">
                <input
                  type="text"
                  placeholder="Enter Wholesale Reserve Price"
                  class="form-control"
                  v-model="units1.wholesale_reserveprice"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <label><h5>Unit 2</h5></label>
          <div class="col-md-12">
            <div class="form-group mb-3">
              <label>Unit Name<span class="text-danger">*</span></label>
              <model-list-select
                :list="Units ? Units : []"
                v-model="units2.unit"
                option-value="id"
                option-text="name"
                class="mb-3"
                placeholder="Select Other Units"
              >
              </model-list-select>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-3">
              <label>Product Code</label>
              <div class="input-group">
                <input
                  type="text"
                  placeholder="Product Unit Code"
                  class="form-control"
                  v-model="units2.code"
                />
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-3">
              <label>Base Quantity</label>
              <div class="input-group">
                <input
                  type="number"
                  placeholder="Base Quantity"
                  class="form-control"
                  v-model="units2.base_quantity"
                />
              </div>
              <div class="text-danger" v-if="UnitqtyError">
                <em>{{ UnitqtyError }}</em>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-3">
              <label>Selling Price <span class="text-danger">*</span></label>
              <div class="input-group">
                <input
                  type="text"
                  placeholder="Enter Product Unit Selling Price"
                  class="form-control"
                  v-model="units2.selling_price"
                  @input="addUnitSellCommas2()"
                />
              </div>
              <div class="text-danger" v-if="sellingPriceError">
                <em>{{ sellingPriceError }}</em>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-3">
              <label>Reserve Price</label>
              <div class="input-group">
                <input
                  type="text"
                  placeholder="Enter Reserve Price"
                  class="form-control"
                  v-model="units2.reserve_price"
                  @input="addUnitReserveCommas2()"
                />
              </div>
            </div>
          </div>
          <div
            class="col-md-12"
            v-if="GeneralSettings.enable_wholeselling == 1"
          >
            <div class="form-group mb-3">
              <label>Wholesale Price</label>
              <div class="input-group">
                <input
                  type="text"
                  placeholder="Enter Wholesale Unit Selling Price"
                  class="form-control"
                  v-model="units2.wholesale_unitprice"
                />
              </div>
            </div>
          </div>
          <div
            class="col-md-12"
            v-if="GeneralSettings.enable_wholeselling == 1"
          >
            <div class="form-group mb-3">
              <label>Wholesale reserve Price</label>
              <div class="input-group">
                <input
                  type="text"
                  placeholder="Enter Wholesale Reserve Price"
                  class="form-control"
                  v-model="units2.wholesale_reserveprice"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeUnitModal('add-productunit-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="addProductUnit('add-productunit-modal')"
        >
          <i class="fa fa-check"></i>
          Submit
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Spinning"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!--SYNC PDTS  MODAL-->
    <b-modal
      id="synch-products-modal"
      ref="modal"
      hide-footer
      title="Synchronize products to Efris"
    >
      <div class="mb-2">
        <h5>
          You are synchronizing pending products to Efris, click synchronize to
          proceed
        </h5>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-secondary"
          @click="closeModal('synch-products-modal')"
          type="button"
        >
          Close
        </button>
        <button
          class="btn btn-primary"
          type="button"
          @click="SyncPdts('synch-products-modal')"
        >
          Synchronize
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            role="status"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- SYNC PDTS MODAL END -->

    <!-- IMPORT EFRIS PDTS -->
    <b-modal
      id="efris-products-modal"
      ref="modal"
      hide-footer
      title="Import efris products"
    >
      <div class="modal-footer">
        <button
          class="btn btn-secondary"
          @click="closeModal('efris-products-modal')"
          type="button"
        >
          Close
        </button>
        <button
          class="btn btn-primary"
          type="button"
          @click="ImportEfrisPdts('efris-products-modal')"
        >
          Import
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            role="status"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- IMPORT EFRIS PDTS -->

    <!-- IMPORT EFRIS PDTS TAX-->
    <b-modal
      id="efris-tax-modal"
      ref="modal"
      hide-footer
      title="Update Products Tax Category Code"
    >
      <div class="modal-footer">
        <button
          class="btn btn-secondary"
          @click="closeModal('efris-tax-modal')"
          type="button"
        >
          Close
        </button>
        <button
          class="btn btn-primary"
          type="button"
          @click="ImportEfrisTax('efris-tax-modal')"
        >
          Update
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            role="status"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- IMPORT EFRIS PDTS TAX-->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
